import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { getAvatar } from '../../helpers'

interface NewVideoToastProps {
  brief: string
  briefApplication: string
  name: string
  avatar?: string
  gif?: string
  briefName?: string
  closeToast?: () => void
}

const NewVideoToast: FC<NewVideoToastProps> = ({
  brief,
  briefApplication,
  name,
  avatar,
  gif,
  briefName,
  closeToast,
}) => {
  const navigate = useNavigate()
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => {
        navigate(`/dashboard/castings/${brief}/briefapplication/${briefApplication}`)
        closeToast?.()
      }}
      className="flex items-center gap-3 cursor-pointer py-0.5"
    >
      <div className="relative h-11 w-11 shrink-0">
        <img
          src={gif || getAvatar('male', avatar)}
          alt={name}
          className="h-11 w-11 rounded-xl border-2 border-white object-cover shadow-sm"
        />
        <span className="absolute -bottom-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-[#7885ed] text-white">
          <i className="fa-solid fa-play text-[9px]" />
        </span>
      </div>
      <div className="flex min-w-0 flex-col">
        <span className="flex items-center gap-1.5 text-[13px] font-bold leading-tight text-[#23262E]">
          <i className="fa-solid fa-film text-[#7885ed]" />
          Nouvelle vidéo de {name}
        </span>
        {briefName && (
          <span className="max-w-[220px] truncate text-[12px] text-[#7C7C7C]">
            Casting&nbsp;: {briefName}
          </span>
        )}
        <span className="mt-0.5 text-[11px] font-semibold text-[#7885ed]">
          Voir la vidéo →
        </span>
      </div>
    </div>
  )
}

export const showNewVideoToast = (params: {
  brief: string
  briefApplication: string
  name: string
  avatar?: string
  gif?: string
  briefName?: string
}) => {
  toast(
    ({ closeToast }) => <NewVideoToast {...params} closeToast={closeToast} />,
    {
      autoClose: 7000,
      closeOnClick: false,
      icon: false,
      pauseOnHover: true,
      position: 'top-right',
    }
  )
}

export default NewVideoToast
